import * as Sentry from '@sentry/nextjs'
import { formatCurrency, formatDate } from '../utils'
import { useEffect, useState } from 'react'

import { Invoice } from '../types/types'
import { getInvoices, getInvoicePdf } from '../services/SubscriptionApiClient'
import Spinner from '../components/Spinner'

import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { NondescriptError } from '../components/NondescriptError'
import { NetworkError } from '../services/Errors'

function Receipts() {
  const [invoices, setInvoices] = useState<Invoice[]>([])
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      The amount charged from your account might be <b>less</b> than is
      displayed here to adjust for a previous payment. Look at the receipt to
      see the exact amount charged.
    </Tooltip>
  )

  const getInvoicePdfHere = async (
    invoiceId: string,
    invoiceNumber: string,
  ) => {
    const pdfBase64 = await getInvoicePdf(invoiceId)
    const downloadFile = (blob: Blob, fileName: string) => {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      document.body.append(link)
      link.click()
      link.remove()
      setTimeout(() => URL.revokeObjectURL(link.href), 7000)
    }

    downloadFile(
      new Blob([Buffer.from(pdfBase64, 'base64')], {
        type: 'application/pdf;charset=utf-8',
      }),
      `${invoiceNumber}.pdf`,
    )
  }

  useEffect(() => {
    async function getData() {
      // TODO JE: Think about pagination.
      try {
        setInvoices(await getInvoices())
      } catch (e) {
        Sentry.captureException(e)
        console.log(e)
        setError(true)
      }
    }
    getData().then(() => setLoaded(true))
  }, [])

  if (!loaded) {
    return <Spinner />
  }

  if (loaded && error) {
    return <NondescriptError />
  }

  return (
    <>
      <div className="mb-60">
        <h2 className="h4">Receipts</h2>
        <hr />
        <div className="plus-card mb-20">
          <table className="w-100">
            <thead className="plus-card-description">
              <tr>
                <th className="p-15">Date</th>
                <th className="p-15">Reference number</th>
                <th className="p-15">Description</th>
                <th className="p-15">Amount</th>
              </tr>
            </thead>
            <tbody>
              {invoices
                .filter((invoice) => parseFloat(invoice.total) > 0)
                .map((invoice) => {
                  return (
                    <tr key={invoice.invoiceId}>
                      <td className="p-15">{formatDate(invoice.dueAt)}</td>
                      <td className="p-15">
                        <button
                          className="btn btn-link"
                          onClick={() =>
                            getInvoicePdfHere(
                              invoice.invoiceId!,
                              invoice.invoiceNumber!,
                            )
                          }>
                          {invoice.invoiceNumber}
                        </button>
                      </td>
                      <td className="p-15">Reason+ Subscription</td>
                      <td className="p-15">
                        {formatCurrency(invoice.total, invoice.currency)}
                        {invoice.creditsApplied && (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip}>
                            <span>
                              &nbsp;
                              <i className="fa fa-exclamation-circle color-stone-5"></i>
                            </span>
                          </OverlayTrigger>
                        )}
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
      <p>
        Orders from the shop will soon be visible here. Meanwhile they can be
        found at the{' '}
        <a
          href={`${process.env.NEXT_PUBLIC_CLOWN_URL}/user/orders`}
          target="_blank"
          rel="noreferrer">
          Orders page.
        </a>
      </p>
    </>
  )
}

export default Receipts
